/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { representativesCreate } from "../../funcs/representativesCreate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateRepresentativeRequest$inboundSchema,
};

export const tool$representativesCreate: ToolDefinition<typeof args> = {
  name: "representatives-create",
  description:
    `Moov accounts associated with businesses require information regarding individuals who represent the business. 
You can provide this information by creating a representative. Each account is allowed a maximum of 7 representatives. 
Read our [business representatives guide](https://docs.moov.io/guides/accounts/requirements/business-representatives/) to learn more.

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/accounts/{accountID}/representatives.write\` scope.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await representativesCreate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
